<template>
  <div class="visitors-manage">
    <div style="padding-bottom: 10px;">
      <el-form size="small" :inline="true" class="demo-form-inline" :model="form">
        <el-form-item :label="$t('message.name')">
          <el-input v-model="form.name" clearable>
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('message.phone')">
          <el-input v-model="form.phone_number" clearable>
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('message.identity_card')">
          <el-input v-model="form.id_number" clearable>
          </el-input>
        </el-form-item>
        <template v-if="org_type === 'COMPANY'">
          <el-form-item :label="$t('message.reception')">
            <el-input v-model="form.interviewee_name" clearable>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('message.status')">
            <el-select v-model="form.status" clearable>
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item :label="$t('message.arri_time')">
          <el-date-picker
            v-model="form.time"
            value-format="timestamp"
            type="datetimerange"
            :range-separator="$t('message.to')"
            :start-placeholder="$t('message.start_date')"
            :end-placeholder="$t('message.end_date')">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-button size="small" type="primary" @click="searchFilter">{{$t('message.filter')}}</el-button>
      <el-button size="small" @click="exportData">{{$t('message.export')}}</el-button>
    </div>
    <el-table size="small"
              :data="tableData"
              border
              :element-loading-text="$t('message.loading')"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.6)"
              v-loading="tableLoading"
              style="width: 100%;">
      <el-table-column v-for="block in table_header" :label="block.block_name" :key="block.key">
        <template v-for="item in block.items">
          <template v-if="~['faces','dpt_id'].indexOf(item.field_name)"></template>
          <el-table-column
            v-else
            :prop="item.field_name"
            :label="item.cn_name"
            :min-width="getWidth(item.field_name)">
            <template slot-scope="scope">
              <template v-if="item.field_name==='faces'">
                <el-image :preview-src-list="scope.row.faces" fit="contain" style="width: 120px; margin-right: 5px;" v-for="(image, index) in scope.row.faces" :src="image" :key="index">
                </el-image>
              </template>
              <template v-else>
                <template v-if="item.component_type === 'radio'">
                  <template v-if="item.field_name==='gender'">
                    {{scope.row[item.field_name] == 0 ? $t('message.male'):$t('message.female')}}
                  </template>
                  <template v-else>
                    {{scope.row[item.field_name] == 1 ? $t('message.yes'):$t('message.no')}}
                  </template>
                </template>
                <template v-else-if="item.component_type === 'time'">
                  {{$options.filters.timeFilter(scope.row[item.field_name], 'yyyy-MM-dd')}}
                </template>
                <template v-else>
                  {{scope.row[item.field_name]}}
                </template>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table-column>
      <el-table-column prop="purpose" :label="$t('message.arri_purpose')"> </el-table-column>
      <template v-if="org_type === 'COMPANY'">
        <el-table-column
          prop="status"
          :label="$t('message.status')">
          <template slot-scope="scope">
            {{checkType[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column prop="interviewee_name" :label="$t('message.reception')"></el-table-column>
        <el-table-column prop="work_unit" :label="$t('message.work_unit')"></el-table-column>
        <el-table-column
          width="200"
          :label="$t('message.effective_time')">
          <template slot-scope="scope">
            <template v-if="scope.row.start_time">
              {{ $options.filters.timeFilter(scope.row.start_time, 'yyyy-MM-dd hh:mm') }} {{$t('message.to')}} {{ $options.filters.timeFilter(scope.row.end_time, 'yyyy-MM-dd hh:mm') }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('message.arri_time')">
          <template slot-scope="scope">
            {{ scope.row.access_time&&$options.filters.timeFilter(scope.row.access_time, 'yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="health_status"
          :label="$t('message.healty_status')">
          <template slot-scope="scope">
            <span v-if="scope.row.health_status === 'healthy'">{{$t('message.normal')}}</span>
            <span v-if="scope.row.health_status === 'unhealthy'">{{$t('message.abnormal')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="temperature" :label="$t('message.temperature_body')+'(℃)'"></el-table-column>
        <el-table-column
          :label="$t('message.symptoms')"
          min-width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.symptoms && scope.row.symptoms.length">
              <el-tag v-for="ill in scope.row.symptoms" :key='ill' type='danger' size='small' style='margin: 3px;'>{{ill}}</el-tag>
            </div>
            <el-tag v-else type='info' size='small'>{{$t('message.unsymptoms')}}</el-tag>
          </template>
        </el-table-column>
      </template>
      <template v-else>
        <el-table-column
          :label="$t('message.arri_time')">
          <template slot-scope="scope">
            {{ $options.filters.timeFilter(scope.row.access_time, 'yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
      </template>
      <el-table-column
        :label="$t('message.operate')"
        min-width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="deletePerson(scope.row)">{{$t('message.del')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="text-align: right; margin-top: 10px;"
      background
      :page-size="pageSize"
      @current-change="changePage"
      :current-page="currentPage"
      layout="total, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
  // @ is an alias to /src
  import SinglePersonFilter from '../components/SinglePersonFilter'
  import { deleteEmptyValue } from '../utils'

  export default {
    name: 'PersonManage',
    data () {
      return {
        org_type: '',
        locationDialog: false,
        form:{
          name: '',
          phone_number: '',
          id_number: '',
          status: '',
          time: []
        },
        table_header: [],
        tableData: [],
        tableLoading: false,
        pageSize: 10,
        currentPage: 1,
        total: 0,
        checkType:{0:'待上报',1:'待审批',2:'已通过',3:'未通过',4:'已来访'},
        statusList:[{
          name:'待上报',
          id: 0
        },{
          name:'待审批',
          id: 1
        },{
          name:'已通过',
          id: 2
        },{
          name:'未通过',
          id: 3
        },{
          name:'已来访',
          id: 4
        }]
      }
    },
    components: {
      SinglePersonFilter
    },
    created () {
      let info = localStorage.getItem('ManageUserInfo')&&JSON.parse(localStorage.getItem('ManageUserInfo'))||{};
      this.org_type = info.organization_type;
      this.search();
      let lang = localStorage.getItem('lang');
      if(lang&&lang==='en') {
        this.checkType={
          0:this.$t('message.to_report'),
          1:this.$t('message.to_check'),
          2:this.$t('message.passed'),
          3:this.$t('message.un_pass'),
          4:this.$t('message.visited'),
        }
        this.statusList = [{
          name:this.$t('message.to_report'),
          id: 0
        },{
          name:this.$t('message.to_check'),
          id: 1
        },{
          name:this.$t('message.passed'),
          id: 2
        },{
          name:this.$t('message.un_pass'),
          id: 3
        },{
          name:this.$t('message.visited'),
          id: 4
        }]
      }
      
    },
    methods: {
      deletePerson (person) {
        this.$confirm(this.$t('message.whether_del_visiter'), this.$t('message.confirm_info'), {
          distinguishCancelAndClose: true
        }).then(() => {
          this.axios.delete('admin/visitor', { params: { id: person.id } }).then(response => {
            if (response.data.code === 200) {
              this.$message({
                message: this.$t('message.del_success'),
                type: 'success'
              })
              this.search()
            }
          }).catch(error => {
            this.$message({
              message: error || this.$t('message.service_error'),
              type: 'error'
            })
          })
        }).catch(action => {
        })
      },
      getWidth(field_name) {
        switch(field_name) {
          case 'faces':
            return 400
          case 'dpt_id':
            return 120
        }
      },
      exportData () {
        const { page, per_page, ...condition } = this.genCondition();
        condition.type='export';
        this.axios({
          method: 'get',
          url: 'admin/visitor/list',
          params: condition,
          responseType: 'arraybuffer'
        }).then(r => {
          if (r.data.code === 500) {
            this.$message({
              message: this.$t('message.export_fail'),
              type: 'error'
            })
          } else {
            let blob = new Blob([r.data], { type: 'application/xls' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${this.$options.filters.timeFilter(Date.now() / 1000)}.xls`
            link.click()
          }
        }).catch(() => {
          this.$message({
            message: this.$t('message.export_fail'),
            type: 'error'
          })
        })
      },
      searchFilter () {
        this.currentPage = 1
        this.search()
      },
      genCondition () {
        let condition = {
              per_page: this.pageSize,
              page: this.currentPage
            };
        Object.keys(this.form).forEach(v=>{
          let value = this.form[v];
          if(value||value===0){
            if(v === 'time') {
              if(value.length){
                condition.from = (value[0]/1000).toFixed(0);
                condition.to = (value[1]/1000).toFixed(0);
              }
            } else {
              condition[v] = value;
            }
          }
        });

        return deleteEmptyValue(condition)
      },
      search () {
        const condition = this.genCondition()
        this.tableLoading = true
        this.axios.get('admin/visitor/list', { params: condition }).then(response => {
          this.tableLoading = false
          if (response.data.code === 200) {
            const data = response.data.data;
            let header = data.table_header, showHeader=[];
            if(header&&header.length){
              this.total = data.total;
              this.tableData = data.list;
              header.forEach(v=>{
                if(!~['detail_location', 'members'].indexOf(v.key)){
                  showHeader.push(v)
                }
              })
            } else {
              this.tableData=[]
              this.total = 0;
            }
            this.table_header= showHeader
          }
        }).catch(error => {
          this.$message({
            message: error || this.$t('message.service_error'),
            type: 'error'
          })
          this.tableLoading = false
        })
      },
      changePage (page) {
        this.currentPage = page
        this.search()
      }
    }
  }
</script>

<style lang="scss">
.visitors-manage {
  .el-select .el-input {
    width: 100px !important;
  }
}
</style>
